export default function YouTubeEmbed({ videoId }) {
  return (
    <div className="relative w-full md:max-w-3xl mx-auto pb-0 h-[20rem]">
      {/* Aspect ratio container */}
      <iframe
        src={videoId}
        title="YouTube video player"
        className=" w-full rounded-t-lg rounded-lb-none md:rounded-tr-none md:rounded-l-lg h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        data-aos="fade-right"
      ></iframe>
    </div>
  );
}
